import React from 'react';
import { useForm } from 'react-hook-form';

import Button from '@/components/Primitive/Button/Button';
import SelectField from '@/components/Primitive/SelectField/SelectField';
import TextField from '@/components/Primitive/TextField/TextField';

export type ContactFormData = {
  name: string;
  email: string;
  subject: string;
  message: string;
};

interface IGuestForm {
  error: string;
  isSuccess: boolean;
  isLoading: boolean;
  onSubmit: (data: ContactFormData) => Promise<void>;
}

const formOptions = [
  {
    label: 'Select a subject',
    value: '',
  },
  {
    label: 'General Enquiries',
    value: 'general',
  },
  {
    label: 'Player Support',
    value: 'player-support',
  },
  {
    label: 'Recruitment',
    value: 'recruitment',
  },
  {
    label: 'Casting',
    value: 'casting',
  },
  {
    label: 'Investment',
    value: 'investment',
  },
  {
    label: 'Partnerships',
    value: 'partnerships',
  },
  {
    label: 'Press',
    value: 'press',
  },
];

const ContactForm = ({ onSubmit, isLoading, isSuccess, error }: IGuestForm) => {
  const { register, handleSubmit } = useForm<ContactFormData>();

  const _onSubmit = async (formData: ContactFormData) => {
    await onSubmit(formData);
  };

  return (
    <div className="flex w-full flex-col items-center justify-center">
      {isSuccess && (
        <div className="flex w-full flex-col items-center justify-center py-12 text-center">
          <h2 className="font-dharma text-5xl font-black uppercase italic leading-none text-cream">
            Thank you!
          </h2>
          <p className="text-lg text-cream">Message sent successfully! </p>
        </div>
      )}

      {!isSuccess && (
        <form
          name="contact"
          onSubmit={handleSubmit(_onSubmit)}
          className="flex w-full max-w-[650px] flex-col items-center justify-center space-y-4 md:space-y-10"
        >
          <TextField
            id="name"
            {...register('name')}
            className="w-full"
            label="Your name"
            required
          />
          <TextField
            id="email"
            {...register('email')}
            className="w-full"
            label="Your email"
            required
          />
          <TextField
            id="message"
            {...register('message')}
            className="w-full"
            type="text"
            label="Tell us more"
            required
          />
          <SelectField
            className="w-full"
            {...register('subject')}
            id="subject"
            options={formOptions}
            required
          />

          {error && <p className="mr-0 text-red-500">{error}</p>}
          <Button
            loading={isLoading}
            className="mx-auto uppercase"
            type="submit"
          >
            Submit
          </Button>
        </form>
      )}
    </div>
  );
};

export default ContactForm;
